// external dependencies
import React from 'react'
import { bool, func, string } from 'prop-types'
import styled from '@emotion/styled'

// components
import { ChevronBlock } from '@jelly/components'

// styled components
const IconWrap = styled.div`
	align-items: center;
	background-color: ${({ theme }) => theme.colors.orange};
	display: flex;
	cursor: pointer;
	height: 41px;
	justify-content: center;
	left: ${({ direction }) => direction === 'left' && '0'};
	position: absolute;
	right: ${({ direction }) => direction === 'right' && '0'};
	transform: ${({ direction }) => direction === 'left' && 'scaleY(-1) rotate(180deg)'};
	width: 30px;
	z-index: 1;

	${({ theme }) => theme.MQ.M} {
		${({ displayArrow }) => !displayArrow && `display: none;`}
	}
`

TabArrow.propTypes = {
	direction: string,
	displayArrow: bool,
	onClick: func.isRequired,
}

export function TabArrow({ direction, displayArrow, onClick }) {
	return (
		<IconWrap direction={direction} onClick={onClick} displayArrow={displayArrow}>
			<ChevronBlock height="30px" width="30px" fill="#fff" />
		</IconWrap>
	)
}
